import { Star } from "lucide-react";
import { Badge } from "@/components/ui/badge";

interface ProductRatingBadgeProps {
  rating: number | null | undefined;
  className?: string;
}

export function ProductRatingBadge({ rating, className = "" }: ProductRatingBadgeProps) {
  if (rating === null || rating === undefined || rating <= 0) return null;

  return (
    <Badge variant="secondary" className={`shrink-0 gap-1 ${className}`}>
      <Star className="h-3 w-3 fill-amber-500 text-amber-500" />
      {rating.toFixed(1)}
    </Badge>
  );
}
